/* eslint-disable */

import { Box, Button, CircularProgress, Grid, Modal, TextField } from '@mui/material'

import classes from './StockThresholdSingleEdit.module.css'

import { useState } from 'react'
import { WarehouseStock } from '../../../model/models-module'
import { Formik } from 'formik'
import InputFilter from '../../../components/common/input-filter/InputFilter'
import WarehouseStockService from '../../../services/WarehouseStockService'
import PopupSuccessError from '../../../components/common/popup-success-error/PopupSuccessError'
import UserService from '../../../services/UserService'

interface SingleEditModalProps {
  open: boolean
  onClose: (e?: any, reason?: string) => void
  item: WarehouseStock
}

const StockThresholdSingleEdit = ({ open, onClose, item }: SingleEditModalProps) => {
  const [showSpinner, setShowSpinner] = useState<boolean>(false)
  const [showPopupSuccessError, setShowPopupSuccessError] = useState<boolean>(false)
  const [dataResponseSuccess, setDataResponseSuccess] = useState<boolean>(false)
  const service: WarehouseStockService = WarehouseStockService.Instance

  const addCommas = (num: string) => num.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const removeNonNumeric = (num: string) => num.replace(/[^0-9]/g, "");

  return (
    <Modal open={open} onClose={onClose} className={'dialog-lg'}>
      <>
        {showSpinner ? (
          <Box
            style={{
              position: 'fixed',
              height: '100%',
              width: '100%',
              textAlign: 'center',
              zIndex: '1201',
              left: '0',
              top: '0',
              background: '#00000026',
            }}
          >
            <CircularProgress style={{ marginTop: 'calc(50vh - 20px)' }} />
          </Box>
        ) : null}
        <Box className={classes.modalContainer}>
          <span className={classes.modalTitle}>Edición Individual</span>

          <Box sx={{ backgroundColor: '#f5f5f5', width: '100%', borderRadius: '10px'}}>
            <Formik
              initialValues={item || { stockMinimum: 0 }}
              validate={(values) => {
                const errors: any = {}
                const stockMinimum = Number(removeNonNumeric(values.stockMinimum?.toString() || ''))
                const stockMaximun = Number(removeNonNumeric(values.stockMaximun?.toString() || ''))
                const stockMinimumTransfer = Number(removeNonNumeric(values.stockMinimumTransfer?.toString() || ''))
                if (
                  stockMaximun &&
                  stockMinimum &&
                  stockMaximun < stockMinimum
                ) {
                  errors.stockMaximun =
                    'El Stock Máximo debe ser mayor que el Stock Mínimo.';
                }

                if (!stockMaximun ) {
                  errors.stockMaximun = 'El Stock Máximo debe ser mayor que 0.'
                }

                if (
                  stockMaximun &&
                  stockMinimum &&
                  stockMaximun < stockMinimum
                ) {
                  errors.stockMinimum =
                    'El Stock Minimo debe ser menor que el Stock Máximo.';
                }

                if (!stockMinimumTransfer) {
                  errors.stockMinimumTransfer =
                    'El Stock Máximo debe ser mayor que 0.';
                }

                if (
                  stockMinimum &&
                  stockMaximun &&
                  stockMinimumTransfer &&
                  (stockMinimumTransfer <= stockMinimum ||
                    stockMinimumTransfer >= stockMaximun)
                ) {
                  errors.stockMinimumTransfer =
                    'El Stock Mínimo Transferible debe estar entre el Stock Mínimo y el Stock Máximo.';
                }

                return errors
              }}
              onSubmit={async (values, { setSubmitting }) => {
                const stockMinimum = Number(removeNonNumeric(values.stockMinimum?.toString() || ''))
                const stockMaximun = Number(removeNonNumeric(values.stockMaximun?.toString() || ''))
                const stockMinimumTransfer = Number(removeNonNumeric(values.stockMinimumTransfer?.toString() || ''))
                
                const valuesToSubmit = {
                  stockMinimum,
                  stockMaximun,
                  stockMinimumTransfer,
                }
                if (item.id) {
                  setShowSpinner(true)
                  try {
                    await service.updateById(item.id, valuesToSubmit)
                    setShowSpinner(false)
                    setDataResponseSuccess(true)
                    setShowPopupSuccessError(true)
                  } catch (error) {
                    console.error('Error al actualizar:', error)
                    setDataResponseSuccess(false)
                    setShowSpinner(false)
                    setSubmitting(false)
                    setShowPopupSuccessError(true)
                  }
                }
              }}
            >
              {({ handleSubmit, setFieldValue, values, errors, touched }) => (
                <form onSubmit={handleSubmit}>
                  <Grid container className={`${classes.grid}`} columnSpacing={4} rowSpacing={4} padding={4}>
                      <Grid item xs={6}>
                        <Box className={classes.gridItem}>
                          <label htmlFor='warehouse'>Almacén</label>
                          <TextField
                            disabled={true}
                            className={classes.formField}
                            value={values.warehouse?.description}
                            onChange={(e) => {
                              setFieldValue('warehouse', e)
                            }}
                            ></TextField>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box className={classes.gridItem}>
                          <label htmlFor='sku'>SKU</label>
                          <TextField
                            disabled={true}
                            className={classes.formField}
                            value={values.sku}
                            onChange={(e) => {
                              setFieldValue('sku', e)
                            }}
                          ></TextField>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box className={classes.gridItem}>
                          <label htmlFor='product_description'>Descripción</label>
                          <TextField
                            disabled={true}
                            className={classes.formField}
                            value={values.productDescription}
                            onChange={(e) => {
                              setFieldValue('product_description', e)
                            }}
                          ></TextField>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box className={classes.gridItem}>
                          <label htmlFor='stockMinimum' className={classes.required}>
                            Stock Mínimo
                          </label>
                          <TextField
                            className={`${classes.formField} ${errors.stockMinimum && touched.stockMinimum ? classes.error : ''} no-spin`}
                            value={values.stockMinimum}
                            onChange={(e) => {
                              const input = removeNonNumeric(e.target.value);
                              const numericValue = parseInt(input, 10);

                              if (input === "") {
                                // Permite vaciar el campo
                                setFieldValue('stockMinimum', "");
                              } else if (!isNaN(numericValue) && numericValue <= 9999) {
                                // Solo actualiza si está dentro del rango permitido
                                setFieldValue('stockMinimum', addCommas(numericValue.toString()));
                              }
                            }}
                            InputProps={{
                              inputMode: 'numeric',
                            }}
                            disabled={!UserService.hasPermission('accion:gestion:configurarumbrales-min-max-mintrf-almacen:editar')}
                            inputProps={{
                              min: 0,
                              max: 9999,
                            }}
                          ></TextField>
                          {errors.stockMinimum && touched.stockMinimum ? (
                            <span className={classes.errorMsg}>
                              {errors.stockMinimum && touched.stockMinimum && errors.stockMinimum}
                            </span>
                          ) : null}
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box className={classes.gridItem}>
                          <label htmlFor='stockMaximun' className={classes.required}>
                            Stock Máximo
                          </label>
                          <TextField
                            className={`${classes.formField} ${errors.stockMaximun && touched.stockMaximun ? classes.error : ''} no-spin`}
                            value={values.stockMaximun}
                            onChange={(e) => {
                              const input = removeNonNumeric(e.target.value);
                              const numericValue = parseInt(input, 10);

                              if (input === "") {
                                // Permite vaciar el campo
                                setFieldValue('stockMaximun', "");
                              } else if (!isNaN(numericValue) && numericValue <= 9999) {
                                // Solo actualiza si está dentro del rango permitido
                                setFieldValue('stockMaximun', addCommas(numericValue.toString()));
                              }
                            }}
                            InputProps={{
                              inputMode: 'numeric',
                            }}
                            disabled={!UserService.hasPermission('accion:gestion:configurarumbrales-min-max-mintrf-almacen:editar')}
                            inputProps={{
                              min: 0,
                              max: 9999,
                            }}
                          ></TextField>
                          {errors.stockMaximun && touched.stockMaximun ? (
                            <span className={classes.errorMsg}>
                              {errors.stockMaximun && touched.stockMaximun && errors.stockMaximun}
                            </span>
                          ) : null}
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box className={classes.gridItem}>
                          <label htmlFor='stockMinimumTransfer' className={classes.required}>
                            Stock Mínimo Transferible
                          </label>
                          <TextField
                            className={`${classes.formField} ${errors.stockMinimumTransfer && touched.stockMinimumTransfer ? classes.error : ''} no-spin`}
                            value={values.stockMinimumTransfer}
                            onChange={(e) => {
                              const input = removeNonNumeric(e.target.value);
                              const numericValue = parseInt(input, 10);

                              if (input === "") {
                                // Permite vaciar el campo
                                setFieldValue('stockMinimumTransfer', "");
                              } else if (!isNaN(numericValue) && numericValue <= 9999) {
                                // Solo actualiza si está dentro del rango permitido
                                setFieldValue('stockMinimumTransfer', addCommas(numericValue.toString()));
                              }
                            }}
                            InputProps={{
                              inputMode: 'numeric',
                            }}
                            disabled={!UserService.hasPermission('accion:gestion:configurarumbrales-min-max-mintrf-almacen:editar')}
                            inputProps={{
                              min: 0,
                              max: 9999,
                            }}
                          ></TextField>
                          {errors.stockMinimumTransfer && touched.stockMinimumTransfer ? (
                            <span className={classes.errorMsg}>
                              {errors.stockMinimumTransfer &&
                                touched.stockMinimumTransfer &&
                                errors.stockMinimumTransfer}
                            </span>
                          ) : null}
                        </Box>
                      </Grid>
                    </Grid>
                  <Box className={classes['modalButtonContainer']} marginBottom={4}>
                    <Button onClick={onClose} className='button-newsan-grey' variant='contained'>
                      Cerrar
                    </Button>
                    <Button variant='contained' className='button-newsan-red' type='submit'>
                      Confirmar
                    </Button>
                  </Box>
                </form>
              )}
            </Formik>
          </Box>
        </Box>
        {showPopupSuccessError ? (
          <PopupSuccessError
            open={showPopupSuccessError}
            onClose={() => {
              setShowPopupSuccessError(false)
              onClose(undefined, 'confirm')
            }}
            success={dataResponseSuccess}
            successMessage={`Registro actualizado correctamente.`}
            errorMessage={[`El registro no se ha podido actualizar.`]}
          />
        ) : null}
      </>
    </Modal>
  )
}

export default StockThresholdSingleEdit
